import auth from './auth'
import gust from './gust'
import permission from './permission'
import authReject from './authReject'
import signeture from './signeture'
import is_admin from './is_admin'
export default {
  auth, gust, authReject, permission, signeture, is_admin
}